import React, { useRef } from 'react';
import { Fade, Skeleton } from '@mui/material';

import './DocumentListItemIcon.css';
import { useQuarterThumbImage, useHalfThumbImage } from '../../fetch/fetchImage';

export default function ProgressiveThumbnail({ partNumber, documentTypeId, title }) {
    const { image: quarterImage, isLoading: isQuarterImageLoading } = useQuarterThumbImage(documentTypeId != 7 ? partNumber : null);
    const { image, isLoading } = useHalfThumbImage(documentTypeId != 7 && !!quarterImage && !isQuarterImageLoading ? partNumber : null);

    const containerRef = useRef(null)
    const imageDimensions = {
        width: containerRef?.current?.clientWidth ?? 0,
        height: containerRef?.current?.clientHeight
    };


    return (
        <div ref={containerRef}>
            {isQuarterImageLoading ? (
                <Skeleton variant="rectangular" animation="wave" height={imageDimensions.width * 1.29} />
            ) : null}

            <Fade in={!isQuarterImageLoading} timeout={25}>
                <div>
                    <img
                        alt={title}
                        title={title}
                        src={quarterImage}
                        style={{
                            width: '100%', height: '100%',
                            display: !!quarterImage && !isQuarterImageLoading && !image ? 'block' : 'none'
                        }}
                    />
                    <img
                        alt={title}
                        title={title}
                        src={image}
                        style={{
                            width: '100%', height: '100%',
                            display: !!image && !isLoading ? 'block' : 'none'
                        }}
                    />
                </div>
            </Fade>
        </div>
    );
}